import { render, staticRenderFns } from "./p295_smart_buy_card.vue?vue&type=template&id=89b6a8d0"
import script from "./p295_smart_buy_card.vue?vue&type=script&lang=js"
export * from "./p295_smart_buy_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports